import { useState } from 'react';
import * as THREE from 'three';
import { PriceZone } from '../types';

export function useTradingState() {
  const [radialMenuPos, setRadialMenuPos] = useState<{x: number, y: number} | null>(null);
  const [zones, setZones] = useState<PriceZone[]>(() => {
    const saved = localStorage.getItem('priceZones');
    if (saved !== null) {
      try {
        const parsed = JSON.parse(saved) as PriceZone[];
        // Filter out duplicate IDs or fix them
        const seen = new Set<string>();
        return parsed.map(z => {
          if (seen.has(z.id)) {
            return { ...z, id: crypto.randomUUID() };
          }
          seen.add(z.id);
          return z;
        });
      } catch (e) {
        return [];
      }
    }
    return [];
  });
  const [selectedZoneId, setSelectedZoneId] = useState<string | null>(null);
  const [showMarketsPanel, setShowMarketsPanel] = useState(false);
  const [favorites, setFavorites] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem('favorites');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });
  const [activeMarketCategory, setActiveMarketCategory] = useState<string>('Favoritos');
  const [showMobileSettings, setShowMobileSettings] = useState(false);
  const [activeSettingsTab, setActiveSettingsTab] = useState<'dados' | 'visual' | 'estudos' | 'nuvem' | 'vip' | 'controles'>('visual');
  const [showMobileData, setShowMobileData] = useState(false);
  const [isCrosshairActive, setIsCrosshairActive] = useState(false);
  const [cameraTweenTarget, setCameraTweenTarget] = useState<THREE.Vector3 | null>(null);
  const [controlsTweenTarget, setControlsTweenTarget] = useState<THREE.Vector3 | null>(null);
  const [isAIPanelOpen, setIsAIPanelOpen] = useState(false);
  const [aiAnalysis, setAiAnalysis] = useState<string | null>(null);
  const [isAiLoading, setIsAiLoading] = useState(false);

  return {
    radialMenuPos, setRadialMenuPos, zones, setZones, selectedZoneId, setSelectedZoneId, showMarketsPanel, setShowMarketsPanel, favorites, setFavorites, activeMarketCategory, setActiveMarketCategory, showMobileSettings, setShowMobileSettings, activeSettingsTab, setActiveSettingsTab, showMobileData, setShowMobileData, isCrosshairActive, setIsCrosshairActive, cameraTweenTarget, setCameraTweenTarget, controlsTweenTarget, setControlsTweenTarget, isAIPanelOpen, setIsAIPanelOpen, aiAnalysis, setAiAnalysis, isAiLoading, setIsAiLoading
  };
}
